<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" data-test="listHeader">
        Passenger Notification - (Step 7 of 8)
    </ion-list-header>

    <ion-list class="ion-padding" lines="none">

        @if (vm.numDropoffPassengers === 0) {
        <ion-item class="ion-margin" data-test="noDropoffs">
            <span class="infoMsg">This route does not include a drop off.
                No need to send the All Aboard message. Click Next.</span>
        </ion-item>
        }

        @if (vm.numDropoffPassengers > 0) {
        <ion-item data-test="allAboardMsg">
            <ion-label class="ion-text-wrap">
                <span class="line1">Example All Aboard Message</span><br />
                <span class="line2">{{vm.sms.allAboardRenderedMessage}}</span>
            </ion-label>
        </ion-item>
        }

        @if (vm.numDropoffPassengers > 0) {
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Attention Driver: {{vm.driverName}}</span><br />
                <span class="line2">{{greetMessage()}}</span>
            </ion-label>
        </ion-item>
        }
    </ion-list>

    <!-- <pre>{{sentStatuses | json}}</pre> -->
    @if (vm.numDropoffPassengers > 0) {
    <ion-list lines="none">
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">All Aboard Message Sent Status:</span>
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-grid class="ion-no-margin">
                <ion-row>
                    <ion-col size="1" class="header ion-no-margin">
                    </ion-col>
                    <ion-col size="4" class="header ion-no-margin">
                        Customer
                    </ion-col>
                    <ion-col size="2" class="header ion-no-margin">
                        Cell Phone
                    </ion-col>
                    <ion-col size="1" class="header ion-no-margin">
                        Status
                    </ion-col>
                    <ion-col size="4" class="header ion-no-margin">
                        Sent Date
                    </ion-col>
                </ion-row>

                @for (status of vm.sentStatuses; track $index) {
                <ion-row class="ion-text-wrap">
                    <ion-col size="1" class="data ion-no-margin">
                        {{status.sequenceNo}}
                    </ion-col>
                    <ion-col size="4" class="data ion-no-margin">
                        {{status.passengerName}}
                    </ion-col>
                    <ion-col size="2" class="data ion-no-margin">
                        {{status.maskedCellPhone}}
                    </ion-col>
                    <ion-col size="1" class="data ion-no-margin">
                        {{status.sentStatus}}
                    </ion-col>
                    <ion-col size="4" class="data ion-no-margin">
                        {{status.ticket.allAboardDate | myTimestamp : 'EEE, MMM/dd/yyyy, hh:mm:ss:SSS'}}
                    </ion-col>
                </ion-row>
                }
            </ion-grid>
        </ion-item>
    </ion-list>
    }

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext7">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

@if (vm.numDropoffPassengers > 0) {
<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" [disabled]="vb.disabled || vm.step7Complete" expand="full"
            [disabled]="!vm.setting.allAboard.enabled" (click)="onSendSmsAllAboardClick()" data-test="sendMessage">Send
            All Aboard Message</ion-button>
    </ion-toolbar>
</ion-footer>
}